import styled from "styled-components";
import background from "../assets/2022/photos/background.jpeg";
import realizationThree from '../assets/2022/photos/accueil/nouveau/realization-3.jpeg';
import backgroundclean from "../assets/2022/photos/accueil/nouveau/new-background.JPG";

export default styled.div`

    height: 100%;
    display: flex;
    flex-direction: column;

    .heading-info{

      padding: 0 2em;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      h1{
        margin: 0;
        font-size: 30px;
        padding: 0;
        font-weight: 600;
        color: #009444;
        text-align: left;
        font-family: Poppins;
      }

      @media(max-width:768px){
        h1{
          font-size: 20px !important;
        }
      }


      button, a.button{
        color: #009444;
        font-family: Poppins;
        border-radius: 20px;
        text-transform: uppercase;
        font-weight: 500;
        border: 3px solid #009444;
        display: inline-block;
        line-height: 1;
        padding: 12px 18px;
        text-align: center;
        text-decoration: none;
        outline: 0;
        background: white;
        font-size: 13.25px;
        letter-spacing: 0.75px;
        width: 135px;
      }
    }

  #video-playback{

    background-image: url(https://cdn.shopify.com/s/files/1/0606/2725/5548/t/2/assets/untitled-design-34-1-1643130066091.jpeg?v=1643130067);
    background-size: cover;
    background-position: center center;
    padding-bottom: 150px;
    padding-top: 150px;
    opacity: 1;
    text-align: center;

    h1{
      color: #fff;
      font-family: Poppins;
      margin: 0 0 30px;
      padding: 0;
      font-weight: 600;
      font-size: 2.5em;
      letter-spacing: 0.9px;
    }

    button{
      padding-left: 0;
      padding-right: 0;
      border-style: solid;
      border-width: 0 0 3px;
      text-transform: uppercase;
      color: #fff;
      font-family: Poppins;
      border-color: #fff;
      padding-bottom: 7px;
      text-decoration: none;
      outline: none;
      background: none;

      span {
        padding-left: 0.4em;
      }

    }

    @media(max-width: 768px){
      padding-bottom: 75px;
      padding-top: 75px;

      span{
        font-size: 30px;
        line-height: 35px;
      }
    }

  }

  #approache{

    margin: 3em 0;
    padding: 2em 3em;

    @media(max-width: 900px){
      padding: 2em 2em;
    }

    position: relative;
    display: flex;
    min-height: 100px;
    flex-direction: column;

    .row{

      flex-direction: column;

      h1{
        margin: 0;
        font-size: 40px;
        padding: 0 0 10px 0;
        font-weight: 600;
        color: #009444;
        text-align: left;
        font-family: Poppins;
        letter-spacing: 0.9px;
      }

      a{
        margin-top: 2.5em;
        color: #000;
        font-family: Poppins;
        border-color: #009444;
        padding-bottom: 7px;
        padding-left: 0;
        padding-right: 0;
        border-style: solid;
        border-width: 0 0 3px;
        text-transform: uppercase;
        display: inline-block;
        line-height: 1;
        padding: 12px 0px;
        min-width: 100px;
        text-align: left;
        text-decoration: none;
        outline: 0;
      }

      p{
        font-size: 19px;
        font-family: Poppins;
        line-height: 40px;
        margin-bottom: 1.5em;
        color: #2d2d2d;
      }

      ul{
        list-style-type: none;
        li{ width: 100%; float: left; margin: 0.5em 0; }
        img{ float: left; padding-right: 10px; object-fit: contain; width: 35px; }
      }

    }

    .bottom{

      padding: 50px 0;

      h2{
        font-size: 48px;
        color: #2d2d2d;
      }

      @media(max-width: 1024px){
        h2{
          font-size: 60px !important;
          font-weight: 500;
          letter-spacing: -0.9px;
        }

        p{
          font-size: 14px;
          line-height: 36px;
        }

        h2, p{
          text-align: left !important;
          font-weight: 600;
          justify-content: flex-start;
        }

      }

    }


    p{

      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      img{
        height: 25px;
        width: 25px;
        margin: 0.1em 0.5em;
      }

    }



  }

  @media(max-width: 768px){
   h1, #just-more-logos h4{
      font-size: 23px !important;
    }
    p, #distinctions-paragraph, #gray-slider h1{
      font-size: 13px !important;
    }

    #just-more-logos p.image-caption{
      font-size: 13px;
      text-align: center !important;
    }

    #approache p{
      justify-content: flex-start;
      font-weight: 500;
    }
  }

 #gray-slider {
  padding: 40px 25px 50px 25px;
  background-image: none;
  background-size: cover;
  background-position: top;
  background-color: #f5f5f5;
  min-height: 300px;
  text-align: center;
  margin: auto;



  h1{
    text-align: center;
    font-size: 2.35em;
    margin-top: 0.5em;
    padding: 0;
    font-weight: 500;
    color: #000;
  }

  img{
    height: 150px;
    width: 175px;
    object-fit: contain;
    object-position: center;
  }

 }


 #green-slider{

  padding: 20px 0px 0;
  background-image: none;
  background-size: cover;
  background-position: top;
  background-color: #009444;
  min-height: 250px;
  text-align: center;
  margin: auto;

  h1{
    text-align: center;
    font-size: 2.35em;
    margin-top: 0em;
    padding: 0.75em 0 0.5em 0;
    color: white;
    letter-spacing: 0.8px;
  }

  img{
    height: 150px;
    width: 150px;
    object-fit: contain;
    object-position: center;
  }

 }

 @media(max-width: 768px){

   #green-slider img, #gray-slider img{
     height: 150px;
     width: 100px;

   }

   #gray-slider h1, #green-slider h1{
     font-size: 23px !important;
   }
 }

  #nos-solutions, #realizations {

    margin: 1.75em 0 2em;
    padding: 1em 0em;
    position: relative;
    display: flex;
    min-height: 100px;
    flex-direction: column;


    .image-info{

       margin-top: 1em;
       display: flex;
       flex-direction: row;
       flex-wrap: wrap;
       padding: 0 2em;

       span{
         z-index: 1;
        position: relative;
        color: white;
        border: 0 0 3px;
        border-color: white;

       }

       @media(min-width: 1024px){
         width: 100%;
         padding: 0 1.1em 0 1.5em;
       }

       .imageNeedingOverlay{
         position: absolute;
          height: 100%;
          z-index: 1;
          background: rgba(0,0,0,0.2);
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 25px;
          justify-content: center;
          margin: auto;
          align-items: center;
          align-self: center;
       }

      .one, .two, .three, .four{

        .text-wrapper{
            padding-left: 1.7em;
            padding-bottom: 1.7em;
            padding-right: 1.7em;
            position: absolute;
            bottom: 0;

            h3 {
              color: white;
              z-index: 1;
            }

            span{
              bottom: 0;
              padding: 2em 0;
            }

        }

        min-height: 24em;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 1.5em 0;
        padding-right: 1em;
        text-decoration: none;

        img{

          position: absolute;
          background-size: cover;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;
          object-fit: cover;
          object-position: top;
          border-radius: 25px;
          margin: auto;
          left: 0;
          right: 0;

          &::before{
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            height: 100%;
            width: 100%;
            background: rgba(0,0,0,0.9);
            z-index: 0;
          }

        }

        h3,p{
          color: white;
          z-index: 2;
          position: relative;
        }

        h3{
          margin: 0 0 5px;
          font-size: 27px;
          padding-right: 0;
          padding-left: 0;
          font-family: Poppins;
          font-weight: 700;
          color: #fff;
          text-align: left;
        }

        p{
          font-size: 17px;
          margin-top: 0.25em;
        }

      }
    }
  }


  #realizations > .image-info > .text-wrapper {
    display: flex;
    justify-contents: flex-start;
    flex-direction: column;
    align-centers: space-evenly;
  }

  #three-column-info{

      div{
        padding: 0em 1em;
      }

      @media(min-width: 1024px){
        div + div {
          border-left: 2px solid white;
        }
      }

      background-color: #009444;
      padding: 0.65em 2em;

      a,h2,p{
        color: white;
        text-align: center;
        padding: 1px 0;
      }

      h2{
          font-size: 26.5px;
          font-weight: 600;
      }

      p{
      font-family: Poppins;
      color: #fff;
      font-size: 13px;
      line-height: 26px;
      margin-top: 0;
      margin-bottom: 0;
      letter-spacing: 0.9px;
      text-align: center;
      }

  }

  #up {
    z-index: 2;
    position: absolute;
    overflow: hidden;
  }

  #apprende, #nous {
    border: 1px solid rgba(0, 148, 68, 0.5);
    box-sizing: border-box;
    border-radius: 4px;
    font-weight: 500;
  }

  background: white;
  min-height: calc(100% - 125px);

  .header {

    background: url(${background});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    min-height: calc(100vh - 125px);
    padding-bottom: 3em;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;

    .c-w{
      position: relative;
      z-index: 1;
      padding: 0 1em;
    }

    &::after{
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    a{
      margin: .5em 0;
    }

    h2 {
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      font-size: 50px;
      text-align: center;
      color: white;
      font-weight: 600;
      margin-top: 3.25em;
      margin-bottom: 0.05em;
    }

    p {
      font-style: normal;
      font-weight: normal;
      font-weight: 400;
      line-height: 30px;
      font-size: 18px;
      text-align: center;
      color: white;
      margin-bottom: 1.5em;
      letter-spacing: 0.75px;
    }

    @media(max-width: 768px){

      h2{
        font-size: calc(40px/1.3);
        margin-top: 9.25em;
      }

    }

  }

  .btn,
  .btn-inverse {
    text-decoration: none;
    display: inline-block;
  }

  .btn {
    background-color: #009444;
    color: #fff;
    font-family: Poppins;
    border-radius: 20px;
    text-transform: uppercase;
    padding: 7px 30px;
    font-weight: 500;
    margin-right: 15px;
    border: 3px solid #009444;
    font-size: 18.25px;
    letter-spacing: 0.75px;
  }

  .btn-inverse {
    color: #ACBB15;
    border: 1px solid #ACBB15;
    background: transparent;
  }

  @media (min-width: 768px) {
    .mr-r {
      float: right;
      margin-right: 0em;
    }

    .mr-l {
      float: left;
      margin-left: 0em;
    }
  }

  #hasBackgroundImage {
    height: auto;
    width: 100%;
    &.loaded {
      img {
        width: 100%;
        height: 500px;
        object-fit: cover;
        oject-position: center;
      }
    }
    &.not-loaded .pre {
      height: 500px;
      width: 100%;

      background-image: url(${background});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }

  #conseil {
    background: #009444;
    padding: 2.5em 0;
    position: relative;

    h2,
    h4 {
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      font-size: 29px;
      text-align: center;
      color: white;
      font-weight: 600;
      margin-top: 0.8em;
      margin-bottom: 0.8em;
    }

    h4 {
      font-size: 20px;
      color: #009444;
    }

    p {
      font-style: normal;
      font-weight: normal;
      font-weight: 300;
      line-height: 27px;
      font-size: 15px;
      text-align: center;
      color: white;
      margin-bottom: 3em;
    }

    #apprende {
      background: #acbb15;
      color: white;
      border 0;
    }

  }

  .cards {

    margin-top: 2em;
    width: 90%;
    margin-left: 5%;
    float:left;

    .inner {

      min-height: 200px;

      @media(min-width: 1023px){
        width: 95%;
      }

      width: 100%;

      &.full{
        width: 100%;
      }

    }

    .inner {
      background: #ffffff;
      box-shadow: 0px 4px 25px rgba(61, 72, 81, 0.05);
      border-radius: 4px;
      padding: 1em 1em 1.5em;

      .xs-9 {
        padding: 0 0.5em;
      }

    }
  }

  .card {
    margin-top: 1em;
    h4{
      font-size: 19px !important;
    }
    h4,
    p {
      text-align: left !important;
    }

    p {
      margin-bottom: 0 !important;
      font-size: 15px !important;
      color: #3d4851 !important;
    }
    img {
      height: 80px !important;
      width: 100% !important;
      object-fit: contain !important;
      margin: 1.5em 0;
    }
  }

  .nos-services {
    padding: 6em 0 3em;

    h2 {
      margin-bottom: 1.5em;
    }
    h4 {
      line-height: normal;
      font-size: 24px;
      color: #009444;
      font-weight: 300;
      margin-bottom: 0.8em;
    }

    h5 {
      line-height: 27px;
      font-size: 18px;
      color: #3d4851;

      margin-bottom: 1em;
    }

    p {
      line-height: 26px;
      font-size: 16px;
      color: #3d4851;
      font-weight: 300;
      margin-bottom: 1em;
    }

    a {
      line-height: 27px;
      font-size: 18px;
      color: #acbb15;
      text-decoration: none;
    }

    img {

      @media(min-width: 768px){
        width: 90%;
      }

      @media(max-width: 767px){
        width: 100%;
      }

      height: 400px;
      object-fit: cover;
      object-position: top;
      margin: auto;
    }
  }

  .m {
    margin-bottom: 2em;
  }

  #bunch-of-logos {
    min-height: 400px;
    background: #009444;

    .bunch{
      margin-top: 2em;
      margin-bottom: 2em;
    }

    .px400 {
      height: 400px;
    }
    h3 {
      font-style: normal;
      font-weight: 600;
      line-height: 33px;
      font-size: 24px;
      color: white;
    }

    img {
      height: 100px;
      width: 95%;

      object-fit: contain;
      object-position: center;
      background: white;
      border-radius: 5px;
    }

    @media(min-width: 768px){
      img{
        margin: 4% 0;
        height: 90px;
        width: 90%;
      }
    }
  }

  #just-more-logos {

    padding: 1em 3em;
    margin: 4em auto 0;
    position: relative;
    display: flex;
    min-height: 100px;
    flex-direction: column;

    *{
      font-family: Poppins;
    }

    p#distinctions-paragraph{
      text-align: left;
      font-family: Poppins;
      color: #000;
      font-size: 19px;
      line-height: 40px;
      margin-top: 0;
      margin-bottom: 10px;
      letter-spacing: 1px;
      font-weight: 400;
    }

    h4 {
      margin: 0;
      font-size: 30px;
      font-weight: 600;
      color: #009444;
      text-align: left;
      font-family: Poppins;
      line-height: 30px;
      padding: 0px 1.25em 20px 0;
    }

    img {
      background: #ffffff;
      border-radius: 4px;
      object-fit: contain;
      height: 100px;
      margin: 1.5em 0;
    }

    .flex{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    p.image-caption{
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      padding: 0 5% 0 0%;
      color: #3D4851;
      text-align: left;
      margin: 3em 0;
    }

  }

  .in{
    width: 100%;
    margin: auto;
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  @media(max-width: 768px){
    #just-more-logos p#distinctions-paragraph{
      font-size: 13px !important;
      line-height: 30px !important;
    }
  }

  #just-more-logos{
    padding: 0em 1.5em;
  }

  #blog {
    margin: 1em 0;

    h2 {
      margin: 4em 0 2em;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      font-size: 29px;
      color: #222829;
    }
    .post-card {

      margin: 1em 0;

      .inner {
        background: #ffffff;
        box-shadow: 0px 4px 25px rgba(61, 72, 81, 0.05);
        border-radius: 4px;
        min-height: 530px;

        .inner-inner {
          padding: 1.25em;
          height: 355px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
        }

      }

      h3 {
        line-height: 33px;
        font-size: 20px;
        margin: 0.5em 0;
        color: #009444;
        width: 100%;
      }

      p {

        line-height: 26px;
        font-size: 15px;
        font-weight: 300;
        color: #3d4851;
        align-self: flex-start;
        height: 180px;
        overflow: hidden;
        width: 100%;

      }

      img {
        width: 100%;
        height: 230px;
        object-fit: cover;
        object-position: center;
      }

      a {
        display: block;
        font-style: normal;
        font-weight: 600;
        line-height: 27px;
        font-size: 18px;
        text-decoration: none;
        color: #acbb15;
      }
    }
  }

    #coffee{

      height: auto;

      .coffee-h{
        background-image: url(${realizationThree});
        background-size: cover;
        background-position: center;
        padding: 2em 0;
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      h2{
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        font-size: 3em;
        color: #FFFFFF;
      }

      @media(max-width: 768px){
        h2{
          font-size: 2em;
        }
        p{
          font-size: 16px;
        }
      }

      p{
        font-family: Poppins;
        color: #fff;
        font-size: 19px;
        line-height: 30px;
        margin-top: 0;
        margin-bottom: 35px;
        letter-spacing: 1px;
        font-weight: 400;
      }

      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }

      #nous{
        background-color: #009444;
        color: #fff;
        font-family: Poppins;
        border-radius: 20px;
        text-transform: uppercase;
        padding: 5px 30px;
        font-weight: 500;
        margin-right: 1em auto;
        border: 3px solid #009444;
        font-size: 18px;
        letter-spacing: 0.65px;
      }

  }

  #overlay-modal{

    padding: 2em;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1001;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,0.9);
    text-align: center;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    display: flex;

    img{
      height: 70%;
      width: 90%;
      object-fit: contain;
      object-position: center;
    }

    button{
      border: 2px solid white;
      color: white;
      font-weight: 200;
      font-size: 18px;
      padding: 0.5em 1em;
      background: transparent;
      border-radius: 5px;
      position: absolute;
      right: 4.7em;
      top: 4.7em;
    }

  }

  #homepage-gallery{

    padding: 3em 24px;
    position: relative;
    border-bottom: 2px solid #f6f4f4;

    h1 {
      color: #009444;
      font-size: 40px;
      padding: 0.5em 0;
      font-weight: 500;
    }

    #img-one,#img-two,#img-four,#img-five {
      height: 326px;
      width: 100%;
      background: lightgray;
      margin: 1em 0;
      object-fit: cover;
      object-position: top;
    }

    #img-three,#img-one,#img-two,#img-four,#img-five {
      cursor: pointer;
    }

    #img-three{
      height: calc(652px + 2.5em);
      background: lightgray;
      width: 100%;
      margin: 1em 0 0;
      object-fit: cover;
      object-position: center;
    }

  }

  @media(min-width: 1023px){

    #homepage-gallery .two{
      padding: 0px 2em;
    }
  }


  @media(max-width: 768px){

    #three-column-info h2{
      font-size: 20px !important;
      font-weight: 600 !important;
    }

    #homepage-gallery h1{
        font-family: Poppins;
        font-weight: 600;
        margin-bottom: 0;
        text-align: left;
        font-size: 23px;
    }

    #three-column-info div, #three-column-info{
      padding-left: 0.5em !important;
      padding-right: 0.5em !important;
    }

  }


  #socials{

    padding: 3em 0;

    .text-section{
      padding: 0 2em;
    }

    #maps{
      color: #009444;
      font-family: Poppins;
      border-radius: 14px;
      text-transform: uppercase;
      padding: 8px 20px;
      font-weight: 500;
      border: 3px solid #009444;
      -webkit-text-decoration: none;
      text-decoration: none;
      display: inline-block;
      margin-top: 2em;
    }

    li{
      list-style-type: none;
    }

    li a {
      text-align: left;
      font-family: Poppins;
      color: #000;
      font-size: 14px;
      line-height: 30px;
      margin-top: 0;
      letter-spacing: 1px;
      font-weight: 400;
      text-decoration: none;
      margin-bottom: 0;
      padding: 0.5em 0em;
      display: inline-block;

      span{
        font-size: 25px;
        margin-right: 0.25em;
        position: relative;
        top: 2px;
      }

    }

    img{
      height: 80px;
      width: auto;
      text-align: left;
      margin: 2em 0 1em;
    }

    h3{
      margin: 0;
      font-size: 25px;
      line-height: 30px;
      font-weight: 500;
      padding: 0;
      color: #000;
      font-family: Poppins;
    }

    p{
      text-align: left;
      font-family: Poppins;
      color: #000;
      font-size: 15px;
      line-height: 30px;
      margin-top: 0;
      margin-bottom: 10px;
      letter-spacing: 1px;
      font-weight: 400;
    }

  }

  @media(max-width: 768px){
    #three-column-info p, #three-column-info h2{
      text-align: left !important;
    }
  }

  .react-multi-carousel-list{
      z-index: 0;
  }

`;



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/home.style.js